import { createContext, useContext } from "react";

import { useSelector } from "react-redux";

import {
  selectMasterRuleLivestockSaleFieldSchema,
  selectRuleLivestockSaleFieldSchema,
} from "containers/Settings/RuleBooks/Schema/livestockSaleSchema";

const RuleFieldSchemaContext = createContext(false);

export const { Provider: RuleFieldSchema } = RuleFieldSchemaContext;

export function useRuleFieldSchema() {
  const isMasterRule = useContext(RuleFieldSchemaContext);
  return useSelector(
    isMasterRule
      ? selectMasterRuleLivestockSaleFieldSchema
      : selectRuleLivestockSaleFieldSchema,
  );
}
